export function uploadToPresignedUrl(url, headers, file, onProgress) {
    const request = new XMLHttpRequest();
    const done = new Promise((resolve, reject) => {
        request.open("PUT", url);
        Object.entries(headers ?? {}).forEach(([name, value]) => {
            request.setRequestHeader(name, Array.isArray(value) ? value.join(", ") : value);
        });
        request.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                onProgress(event.loaded / event.total);
            }
        };
        request.onload = () => {
            if (request.status >= 200 && request.status < 300) {
                resolve();
            } else {
                reject(new Error(`Upload failed with status ${request.status}`));
            }
        };
        request.onerror = () => reject(new Error("Upload failed"));
        request.onabort = () => reject(new Error("Upload aborted"));
        request.send(file);
    });

    return { done, abort: () => request.abort() };
}
